import NotificationImportantOutlinedIcon from "@mui/icons-material/NotificationImportantOutlined";
import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { AppNotificationContext } from "../../../../context/AppNotificationContext/AppNotificationContext";
import { getUnreadAlertCount } from "../../../../context/AppNotificationContext/reducer/selector";

const GlobalAlertBanner = () => {
  const theme = useTheme();
  const { t } = useTranslation("common");
  const navigate = useNavigate();

  const { alerts, eventsLoaded } = useContext(AppNotificationContext);

  const handleViewAlertsAndNotificationClick = () => {
    navigate("/alerts-notifications-center");
  };

  const unreadAlertCount = getUnreadAlertCount(alerts);

  if (!eventsLoaded || unreadAlertCount === 0) {
    return null;
  }

  return (
    <Box
      data-testid="global-alert-banner"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: theme.tokens.FuelSpacing4,
        backgroundColor: "#FEE7C4",
        padding: `${theme.tokens.FuelSpacing2} ${theme.tokens.FuelSpacing4}`,
        width: "100%",
        height: "52px",
      }}
    >
      <NotificationImportantOutlinedIcon
        sx={{
          color: theme.tokens.FuelColorAlertWarningIcon,
        }}
      />
      <Typography
        sx={{
          color: theme.tokens.FuelColorTextPrimary,
          fontWeight: theme.tokens.FuelFontWeightSemibold,
          fontSize: theme.tokens.FuelFontSizeMd,
          lineHeight: theme.tokens.FuelLineHeightMd,
        }}
        data-testid="global-alert-banner-message"
      >
        {t("globalAlertBanner.message", { count: unreadAlertCount })}
      </Typography>
      <Button
        variant="text"
        onClick={handleViewAlertsAndNotificationClick}
        sx={{
          minWidth: "auto",
          textTransform: "none",
          color: theme.tokens.FuelColorJdGreen,
          fontWeight: theme.tokens.FuelFontWeightSemibold,
          fontSize: theme.tokens.FuelFontSizeSm,
          backgroundColor: "transparent",
          borderRadius: theme.tokens.FuelBorderRadiusSm,
          paddingTop: theme.tokens.FuelSpacing2,
          paddingBottom: theme.tokens.FuelSpacing2,
          paddingLeft: theme.tokens.FuelSpacing4,
          paddingRight: theme.tokens.FuelSpacing4,
          "&:hover": {
            backgroundColor:
              theme.tokens.FuelColorBackgroundActionDefaultHovered,
          },
          "&:active": {
            backgroundColor: theme.tokens.FuelColorGreen100,
          },
        }}
        data-testid="global-alert-banner-link"
      >
        {t("globalAlertBanner.viewAlertsLink")}
      </Button>
    </Box>
  );
};

export default GlobalAlertBanner;
